import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup,  FormBuilder, Validators, FormArray } from '@angular/forms';
import { RequestService } from '../services/request.service';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.css']
})
export class ActivateComponent implements OnInit {
  pageTitle = 'Activar Productos';

  requests: object[] = [];
  users: object[] = [];
  message = '';
  comment = '';

  constructor(
    private requestService: RequestService,
    private formBuilder: FormBuilder
    ) { }

  ngOnInit() {
    this.message = 'Seleccione Listar Solicitudes, para ver las solicitudes del usuario.';
    this.requestService.getRequests().snapshotChanges().subscribe(
      actions => {
        actions.forEach(action => {
        const userEmail = action.key.replace(/\,/g, '.');
        this.requestService.getRequestsForStatus(userEmail, 'pendiente').valueChanges().subscribe(
          (status) => {
            this.users = [];
            this.requestService.getRequestsForStatus(userEmail, 'activo').valueChanges().subscribe(
              (status2) => {
                const req = {
                  email: userEmail,
                  pending: status.length,
                  active: status2.length
                };
                this.users.push(req);
              });
          });
        }, (error) => {
          console.log(error);
        });
      });
  }
  showRequest(email) {
    this.requestService.getRequestsForEmail(email).valueChanges().subscribe(
      (data: Request[]) => {
        this.requests = data;
        if (this.requests.length === 0) {
          this.message = 'El usuario, aún no tiene solicitudes.';
        } else {
          this.message = '';
          this.orderByDate();
        }
      }, (error) => {
        console.log(error);
      });
  }
  orderByDate() {
    this.requests.sort((a, b) => {
      return a['timestamp'] - b['timestamp'];
    });
  }
  orderByState() {
    this.requests.sort((a, b) => {
      const stateA = a['status'];
      const stateB = b['status'];
      let comparison = 0;
      if (stateA > stateB) {
        comparison = 1;
      } else if (stateA < stateB) {
        comparison  = -1;
      }
      return comparison; // reverse return comparison * -1;
    });
  }
  orderByProduct() {
    this.requests.sort((a, b) => {
      const stateA = a['name']; // Use toUpperCase() to ignore character casing
      const stateB = b['name'];
      let comparison = 0;
      if (stateA > stateB) {
        comparison = 1;
      } else if (stateA < stateB) {
        comparison  = -1;
      }
      return comparison;
    });
  }
}
